__webpack_require__.p = "/BeSLighthouse/";